import axios from "axios";
import config from "../config";

const EmailService = {
  post(from, id, subject, content, locale) {
    return axios.post(`${config("API_URL")}/email/`, {
      from: from,
      id: id,
      subject: subject,
      content: content,
      locale: locale
    });
  },

  getEvents(query, locale) {
    return axios.get(`${config("API_URL")}/event`, {
      params: { query: query, locale: locale }
    });
  }
};

export default EmailService;
